import React from 'react'
import {Grid, TextField} from '@material-ui/core'
import KundInput from './Inputs/KundInput'
import {isEmpty, isUndefined, isNull} from 'lodash'
import {useDispatch, useSelector} from 'react-redux'
import {getKundKontakter, getKundAvtalProspekt} from 'actions'
import SelectAvtalProspekt from "../../../SkapaMote/Inputs/SelectAvtalProspekt";
import AvtalsTyp from "./Inputs/AvtalsTyp";

import SelectKontakt from "../../../SkapaMote/Inputs/SelectKontokt";
import KontaktFName from "../../../SkapaMote/Inputs/KontaktFName";
import KontaktLName from "../../../SkapaMote/Inputs/KontaktLName";
import KontaktTele from "../../../SkapaMote/Inputs/KontaktTele";
import KontaktEmail from "../../../SkapaMote/Inputs/KontaktEmail";
import KontaktPersonnummer from "../../../SkapaMote/Inputs/KontaktPersonnummer";
import SelectMedArbetare from "../../../SkapaMote/Inputs/SelectMedArbetare";
import SelectMultiMedArbetare from "../../../SkapaMote/Inputs/SelectMultiMedArbetare";
import IntlMessages from 'util/IntlMessages';

export default function Step1({state, setAktivitet, setState, currentKund, AvtalId}) {
  const dispatch = useDispatch()

  console.log('currentKund', currentKund)

  const KundSearch = useSelector(state => state.accountsData. KundSearch)
  const authUser = useSelector(state => state.auth.authUser)

  const SetAktivitetKundParameters = (Key,Value)=>{
    setAktivitet( 'Kund', {...state.newAktivitet.Kund, [Key]: Value } )
  }

  const selectthisKund=(selectedKund)=>{
    setState(state => ({
        ...state,
        newAktivitet:{
            ...state.newAktivitet,
            personal: 0,
            Kund:{
                KundNamn:KundSearch.KundNamn,
                Orgnr:KundSearch.Orgnr,
                Orgnr_Af:KundSearch.Orgnr_Af,
                Adress:KundSearch.adress,
                Postnr:KundSearch.postnr,
                Ort:KundSearch.ort,
                Source:KundSearch.Source,
                Active:KundSearch.Active,                
            },
            Kontakt:{
                id:"",
                FirstName:"",
                LastName:"",
                Email:"",
                Tele:"",
                PersonNr:""
            },
        }
    }))
    //&& this.props.KundSearch.Source===1
    if(!isUndefined(KundSearch.Orgnr) ){
        const userid = authUser.user_id;
        const Kontoid = authUser.user_Afid;
        dispatch(getKundKontakter(userid,Kontoid,KundSearch.Orgnr))
        dispatch(getKundAvtalProspekt(KundSearch.Orgnr,Kontoid,userid))
    }
  }
  React.useEffect(() => {
    if(KundSearch.Orgnr !== state.newAktivitet.Kund.Orgnr){ 
      selectthisKund()
    }
  }, [KundSearch])
  
  

  const onchangeHanelKontakt2=(Meta,Value)=>{
    setState(state => ({
        ...state,
        newAktivitet:{
            ...state.newAktivitet,
            Kontakt:{
            ...state.newAktivitet.Kontakt,
            [Meta]:Value
            }
        }
    }))
}
const onchangeHanelKontakt=(currenrKontakt)=>{
    setState(state => ({
        ...state,
        newAktivitet:{
            ...state.newAktivitet,
            Kontakt:currenrKontakt
        }
    }))
}

  return (
    <Grid container spacing={2}>
      <Grid item xs={12}>
        <KundInput
           isFrom={0}
           Kund={state.newAktivitet.Kund}             
           onchangeHanelKund={SetAktivitetKundParameters}
           selectthisKund={selectthisKund}
        />
      </Grid>
      <Grid item xs={state.newAktivitet.Kontakt.id !== "" ? 7 : 12}>
        <SelectKontakt
           Kontakter={state.KontakterList}
           Kontokt={state.newAktivitet.Kontakt}
           onchangeHanelKontakt={onchangeHanelKontakt}
        />
      </Grid>
      {
        state.newAktivitet.Kontakt.id !== "" &&
        <>
          <Grid item xs={5}>
            <KontaktPersonnummer
              id={state.newAktivitet.Kontakt.id}
              Personnummer={state.newAktivitet.Kontakt.PersonNr}
              onchangeHanelKontakt={onchangeHanelKontakt2}
              />
          </Grid>
          {
            parseInt(state.newAktivitet.Kontakt.id) === 0 &&
            <>
              <Grid item xs={6}>
                <KontaktFName
                  id={state.newAktivitet.Kontakt.id}
                  FirstName={state.newAktivitet.Kontakt.FirstName}
                  onchangeHanelKontakt={onchangeHanelKontakt2}
                  />
              </Grid>
              <Grid item xs={6}>
                <KontaktLName
                  id={state.newAktivitet.Kontakt.id}
                  LastName={state.newAktivitet.Kontakt.LastName}
                  onchangeHanelKontakt={onchangeHanelKontakt2}
                  />
              </Grid>
            </>
          }
          <Grid item xs={6}>
            <KontaktTele
              id={state.newAktivitet.Kontakt.id}
              Tele={state.newAktivitet.Kontakt.Tele}                    
              onchangeHanelKontakt={onchangeHanelKontakt2}
              />
          </Grid>
          <Grid item xs={6}>
            <KontaktEmail
              id={state.newAktivitet.Kontakt.id}
              Email={state.newAktivitet.Kontakt.Email}
              onchangeHanelKontakt={onchangeHanelKontakt2}
              />
          </Grid>
          
        </>
      }

      <Grid item xs={parseInt(state.newAktivitet.Avtal) === 1 ? 6 : 12}>
        {
          isUndefined(AvtalId) ?
          <SelectAvtalProspekt
            ListOfAVPro={state.ListOfAVPro}
            AvtalId={state.newAktivitet.Avtal}
            selectedthisAvtalId={(Avtal) => setAktivitet('Avtal', Avtal)}
          /> : 
          <TextField
          disabled
          label={<IntlMessages id="appKontoModule.Avtal.Connect"/>}
          fullWidth
          size='small'
          value={'#19'+AvtalId}
          variant="outlined"
         />
        }
        
      </Grid>
      {
        parseInt(state.newAktivitet.Avtal) === 1 &&
        <Grid item xs={6}>
          <AvtalsTyp
            valueavtaltyp={state.newAktivitet.AvtalType}
            selectedthisAvtalType={(AvtalType) => setAktivitet('AvtalType', AvtalType)}
          />
        </Grid>
      }
      <Grid item xs={12}>
        <SelectMedArbetare
          Ansvarig={state.newAktivitet.ansvarig}
          disabled={false}
          onchangeHanelansvarig={(ansvarig) => setAktivitet('ansvarig', parseInt(ansvarig))}
        />
      </Grid>
      <Grid item xs={12}>
        <SelectMultiMedArbetare
          MedArbetare={state.newAktivitet.MedArbetare}
          onchangeHanelMedArbetare={(MedArbetare) => setAktivitet('MedArbetare', MedArbetare)}
          isAktivitet={1}
        />
      </Grid>
    </Grid>
  )
}
